/** Stroke icons (24×24 paths) used in navigation. */
export const ICONS = {
  overview: "M4 4h7v7H4zM13 4h7v4h-7zM13 10h7v10h-7zM4 13h7v7H4z",
  you: "M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm-7 8c0-3.9 3.1-7 7-7s7 3.1 7 7",
  ledger: "M4 6h16M4 12h16M4 18h10",
  people:
    "M9 11a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm7 1a3 3 0 1 0 0-6M3 20c0-3.3 2.7-6 6-6s6 2.7 6 6m1-6c2.8 0 5 2.2 5 5",
  payments: "M3 7h18v10H3zM3 11h18M7 15h3",
  ask: "M5 5h14a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1h-7l-4 3v-3H5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1Zm3 5h.01M12 10h.01M16 10h.01",
  history: "M12 7v5l3 2M3.5 12a8.5 8.5 0 1 0 2.5-6M3 4v4h4",
  receipts: "M6 3h12v18l-3-2-3 2-3-2-3 2zM9 8h6M9 12h6",
  insights: "M5 20V10M12 20V4M19 20v-7",
  settings:
    "M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm7.4-3a7.4 7.4 0 0 0-.1-1.3l2-1.5-2-3.4-2.3.9a7.5 7.5 0 0 0-2.3-1.3L14.4 3h-4l-.3 2.4a7.5 7.5 0 0 0-2.3 1.3l-2.3-.9-2 3.4 2 1.5a7.4 7.4 0 0 0 0 2.6l-2 1.5 2 3.4 2.3-.9a7.5 7.5 0 0 0 2.3 1.3l.3 2.4h4l.3-2.4a7.5 7.5 0 0 0 2.3-1.3l2.3.9 2-3.4-2-1.5c.1-.4.1-.9.1-1.3Z",
  more: "M5 12h.01M12 12h.01M19 12h.01",
  accounts:
    "M12 3l7 3v5c0 4.5-3 8.5-7 10-4-1.5-7-5.5-7-10V6l7-3Zm0 6a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Zm-4 9c.8-1.8 2.3-3 4-3s3.2 1.2 4 3",
  plus: "M12 5v14M5 12h14",
  money: "M3 7h18v11H3zM3 11h18M7 15h3",
  tutoring: "M3 9l9-5 9 5-9 5-9-5zM7 11v5c3 2 7 2 10 0v-5M21 9v6",
  splits: "M7 4v16M17 4v16M3 8h8M13 16h8",
  roadmap: "M4 6l5-2 6 2 5-2v14l-5 2-6-2-5 2zM9 4v14M15 6v14",
  chevron: "M8 10l4 4 4-4",
} as const;
